// eslint-disable-next-line import-x/no-named-as-default
import DS from 'ember-data';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { BookingRentalAgreementSettingValidation } from 'uplisting-frontend/validations';

export default class BookingRentalAgreementSettingRepositoryService extends BaseRepositoryService<
  ModelRegistry['booking-rental-agreement-setting']
> {
  recordName = 'booking-rental-agreement-setting';
  implementMethods = [
    'createRecord',
    'buildChangeset',
    'findRecord',
    'unloadAll',
  ];

  validation = BookingRentalAgreementSettingValidation;

  public async getDefaultRecord(): Promise<
    DS.PromiseObject<ModelRegistry['booking-rental-agreement-setting']>
  > {
    let record;

    try {
      record = await this.findRecord('me');
    } catch {
      record = this.createRecord();
    }

    return record;
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/booking-rental-agreement-setting': BookingRentalAgreementSettingRepositoryService;
  }
}
